<template>
  <img class="uk-svg uk-preserve" :src="require(`@/assets/images/${icon}-icon.svg`)" :alt="icon" :height="height" :width="width" uk-svg />
</template>

<script>
export default {
  name: 'BitOSIcon',
  props: ['icon', 'width', 'height']
}
</script>

<style scoped lang="less">
  @import "../../assets/less/theme.less";

  .uk-svg {
    color: transparent; //fix for SVG polyfill on any background
    fill: @ba-purple;
  }
</style>
